import React from 'react';
import DansMedeelel from './dansMedeelel';

const PageList = () => <DansMedeelel />;

export default PageList;
